import z from "zod";

export const FeatureFlagsSchema = z
  .object({
    signatures: z.boolean(),
    laserfiche: z.boolean(),
    aiMeetingMinutes: z.boolean(),
  })
  .partial();

export const FeatureNameSchema = FeatureFlagsSchema.keyof();
